import React from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { isText, isImageLink } from '@/lib/markdown'

type Props = {
  href: string
  children: React.ReactNode
}

export const MarkdownLink: React.FC<Props> = (props) => {
  if (props.href.startsWith('#')) {
    return <WithinPageLink {...props} />
  }
  return <ExternalLink {...props} />
}

const WithinPageLink: React.FC<Props> = (props) => {
  return (
    <AnchorLink
      href={props.href}
      className={isText(props.children) ? 'text-link' : undefined}
      css={linkCss(isImageLink(props.children))}
    >
      {props.children}
    </AnchorLink>
  )
}

export const ExternalLink: React.FC<Props> = (props) => {
  return (
    <a
      href={props.href}
      target="_blank"
      className={isText(props.children) ? 'text-link' : undefined}
      css={linkCss(isImageLink(props.children))}
    >
      {props.children}
    </a>
  )
}

const linkCss = (isImageLink: boolean) => {
  return css`
    color: ${colors.text};
    border-bottom: 1px dashed ${colors.text};
    padding-bottom: 1px;
    margin: 0 2px;

    &:focus {
      outline: none;
    }
    &:hover {
      color: ${colors.link};
      border-bottom: ${isImageLink ? 'none' : `1px dashed ${colors.link}`};
    }
  `
}
